import { TimePicker as NulogyTimePicker } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React, { useMemo } from "react";

export default function TimePicker({ field: name, onChange, labelText, className }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = useMemo(
    () => (value) => {
      if (onChange) {
        onChange({ setFieldValue, value });
      }
      helpers.setValue(value);
    },
    [onChange, helpers, setFieldValue],
  );

  return (
    <NulogyTimePicker
      className={className}
      errorMessage={meta.error}
      labelText={labelText}
      onChange={handleChange}
      onInputChange={handleChange}
      value={field.value}
    />
  );
}
